import { MoveModal} from "./MoveModal";

export default MoveModal;
